import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import { Settings } from '@material-ui/icons';

class FormSettingsButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool.isRequired,
        formDisabled: PropTypes.bool,
    };

    static defaultProps = {
        formDisabled: true,
    };

    render() {
        const { sendFunc, sendLoading, classes, formDisabled } = this.props;

        if (sendLoading)
            return (
                <div
                    className={formDisabled ? classes.firstPosition : classes.secondPosition}
                    style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <CircularProgress size={25} />
                </div>
            );
        return (
            <div className={formDisabled ? classes.firstPosition : classes.secondPosition}>
                <Tooltip title={Translator.translate('general.settings')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.settings')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={sendFunc}
                    >
                        <Settings className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 15,
        right: 120,
        [theme.breakpoints.down('md')]: {
            top: 15,
            right: 110,
        },
        [theme.breakpoints.down('sm')]: {
            top: 15,
            right: 110,
        },
        [theme.breakpoints.down('xs')]: {
            top: 15,
            right: 110,
        },
    },
    secondPosition: {
        position: 'absolute',
        top: 15,
        right: 180,
        [theme.breakpoints.down('md')]: {
            top: 15,
            right: 170,
        },
        [theme.breakpoints.down('sm')]: {
            top: 15,
            right: 170,
        },
        [theme.breakpoints.down('xs')]: {
            top: 15,
            right: 170,
        },
    },
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    btnEdit: {
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30,
        },
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem',
        },
    },
});

export default withStyles(styles, { withTheme: true })(FormSettingsButton);



// WEBPACK FOOTER //
// ./data/components/FormSettingsButton.js